import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/auth";

import Fab from "@mui/material/Fab";

const pages = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "Cerimonia",
    link: "/cerimonia",
    completed: true,
  },
  {
    name: "Ricevimento",
    link: "/ricevimento",
    completed: true,
  },
  {
    name: "Lista Nozze",
    link: "/lista",
    completed: true,
  },
  {
    name: "Conferma la tua presenza",
    link: "/rsvp",
  },
  {
    name: "Upload file",
    link: "/upload",
    completed: true,
  },
];

function Header({completed}) {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const openDefault = window.location.pathname === "/rsvp" ? completed : false;
  const [open, setOpen] = React.useState(openDefault);

  const handleOpenNavMenu = (event) => {
    setOpen(!open)
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = (event) => {
    setAnchorElNav(null);
  };

  let date = "";
  const { user } = useAuth();
  if (user) {
    date = "27 giugno 2026";
  }

  if (window.location.pathname !== "!") {
    return (
      <>
        <Fab
          size="small"
          color="secondary"
          aria-label="add"
          sx={{
            position: "absolute",
            top: 1,
            right: 1,
          }}
          onClick={handleOpenNavMenu}
        >
          <MenuIcon />
          <Menu
            id="menu-appbar"
            //anchorEl={anchorElNav}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            open={open}
            onClose={handleCloseNavMenu}
            
          >
            {pages.map((page) => {
              if (page?.completed && !completed) {
                return null;
              }
              return (
              <MenuItem key={page.link} href={page.link}>
                <Button
                  key={page.name}
                  //onClick={handleCloseNavMenu}
                  href={page.link}
                  sx={{ color: "black", display: "block", width: "100%" }}
                >
                  {page.name}
                </Button>
              </MenuItem>
            );
          } ) }
          </Menu>
        </Fab>
        <Outlet />
      </>
    );
  }

  return (
    <div>
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar sx={{ pb: 0 }}>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: '"Dancing Script", cursive',
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              Erica & Sonny - {date}
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page.link} onClick={handleCloseNavMenu}>
                    <Button
                      key={page.name}
                      onClick={handleCloseNavMenu}
                      href={page.link}
                      sx={{ color: "black", display: "block" }}
                    >
                      {page.name}
                    </Button>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            {/*<!-- mobile view -->*/}
            <Typography
              variant="h6"
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: '"Dancing Script", cursive',
                fontWeight: 400,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                textAlign: "center",
              }}
            >
              Erica & Sonny
              <br />
              {date}
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              {/* Spacing */}
            </Box>
            <Box sx={{ flexGrow: 0, display: { xs: "none", md: "flex" } }}>
              {pages.map((page) => (
                <Button
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: "black", display: "block" }}
                  href={page.link}
                >
                  {page.name}
                </Button>
              ))}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Outlet />
    </div>
  );
}
export default Header;
